export function analyzePost(post, freeAllowanceLock, hasDeduction, privateActive, deadLinePassed) {
  const status = post.sda_status
  let color = 3
  let applicable = true
  let text = 'Lønnstrekk'
  let header = 'Poster til lønnstrekk'
  let warning = null
  let desc = 'Privat'

  if (status === 0) {
    applicable = false
    color = 0
    text = 'Under behandling'
    header = 'Søknader under behandling'
  }
  if (status === 1) {
    applicable = false
    color = 1
    text = 'Godkjent'
    header = 'Godkjente søknader'
    desc = 'Jobb'
  }
  if (status === 2) {
    color = 2
    text = 'Avslått'
    header = 'Avslåtte søknader'
  }
  if (post.is_locked) {
    applicable = false
    color = 2
    text = 'Denne tjenesten er låst og kan ikke omgjøres til jobbrelatert kost.'
  }
  if (freeAllowanceLock === 0 && post.free_allowance_participant && false) {
    color = 1
    applicable = false
    warning = 'Denne posten dekkes av fribeløp og kan ikke søkes på.'
  } else if (post.p_id === 2141 && false) {
    applicable = false
    warning = 'Motposter kan ikke søkes på.'
  }
  if (deadLinePassed) applicable = false
  return {
    color: color,
    applicable: applicable && hasDeduction && privateActive,
    text: text,
    header: header,
    desc: desc,
    code: status,
    warning: warning,
  }
}
